import React, { Suspense, useState } from "react";
import ProgressBar from "../../Sections/ProgressBar/ProgressBar";
import Modal from "react-modal";
import CloseIcon from "@material-ui/icons/Close";
import imgSrc from "./../../Assets/img/misc/commingSoonCalculator.png";
import "./mobilecalculator/mobileCalculator.css";
import "./../../Sections/CalculatorsSection/CalculatorsSection.css";
function RenderDesktopCalculator(props) {
  const [showModal, setShowModal] = useState(false);
  const calculator = props.calculator;
  const Component = props.calculator.component;
  const modalHandler = () => {
    setShowModal((st) => !st);
  };
  return (
    <div className={"col-12 col-md-4 col-lg-4 mt-3 px-2 mb-3"}>
      <div
        className="calculator-service position-relative"
        id={calculator.name}
      >
        <h5 className="text-center">{calculator.name}</h5>
        <div className="calculator_para_wrapper">
          <p className="calc-box-service" title={calculator.content}>
            {calculator.content}
          </p>
        </div>
        <button
          className="btn d-flex justify-content-center"
          onClick={modalHandler}
        >
          <i className="bx bxs-calculator" style={{ fontSize: "1.4rem" }}></i>
        </button>

        <Modal onRequestClose={modalHandler} isOpen={showModal}>
          <Suspense fallback={<ProgressBar />}>
            <CloseIcon onClick={modalHandler} />
            {Component ? (
              <Component />
            ) : (
              <div className="calculator-not-available calculator__not-available">
                <img src={imgSrc} alt="Calculator not enabled" />
                <p className="text-left pl-2 mt-2">
                  The calculator will be enabled shortly. In the meantime if you
                  have any questions about life insurance then please reach out
                  over phone or email
                </p>
              </div>
            )}
          </Suspense>
        </Modal>
      </div>
    </div>
  );
}

export default RenderDesktopCalculator;
